export const jobExperience = [
  {
    institution: "Continental Hospital Ltd.",
    title: "Software Engineer",
    date: "June, 2025 - Present",
    description: [
      "Developed and maintained core hospital modules, including ERP, HRM, Finance, FNA, and Inventory systems.",
      "Engineered the Continental Patient Portal integrating both frontend and backend systems.",
      "Implemented comprehensive modules for patient management, nursing, doctors, and prescription handling.",
      "Developed robust features for report generation, document printing, and complex billing processes.",
      "Performed overall system optimization, code refactoring, and UI/UX redesigns to significantly improve performance and user experience.",
    ],
  },
  {
    institution: "Shadhin Music Ltd.",
    title: "Software Engineer",
    date: "October, 2024 - June, 2025",
    description: [
      "Engineered a dynamic homepage (https://shadhinmusic.com) capable of rendering thousands of data at once efficiently",
      "Implemented advanced caching strategies using Worker.js and IndexedDB",
      "Applied advanced performance optimization techniques, including code splitting, lazy loading, efficient state management, and asset compression, alongside rigorous code refactoring to enhance maintainability, scalability, and user experience",
      "Transformed Figma designs into pixel-perfect, responsive, and visually engaging user interfaces.",
      "Engineered custom audio and video players with robust, user-centric functionalities.",
      "Executed successful campaigns with major partners, including Grameenphone, Robi, bKash",
    ],
  },
  {
    institution: "Suffix IT Ltd.",
    title: "Software Engineer",
    date: "January, 2021 - September, 2024",
    description: [
      "Developed classified Softwares like:Sales Force, ERP, SAAS Softwares, Inventory Management etc. with React JS & Next.JS For Suffix IT Ltd",
      "Implemented secure authentication using JWT tokens and refresh tokens, ensuring robust user authentication and authorization mechanisms.",
      "Proficient in building role-based applications, allowing for dynamic rendering and access control based on user roles.",
      "Integrated Socket.io to implement live notifications and alerts, enhancing real-time communication and user engagement.",
      "Leveraged custom hooks, Context API, and Redux for efficient state management, ensuring a seamless flow of data throughout the application.",
      "Applied image compression techniques to optimize performance and user experience in handling and displaying images within the application.",
      "Utilized Recharts and Apex Charts for effective data visualization, creating visually appealing and informative charts and graphs.",
      "Generated dynamic reports in both XLSX and PDF formats using libraries like jsPDF, providing users with exportable and printable data.",
      "Contributed to the improvement of application performance and user experience through continuous optimization and refactoring of code.",
      "Collaborated with cross-functional teams to analyze requirements, propose solutions, and deliver high-quality React.js applications on time.",
      "Maximized use of Events and promises in ES6 and React for application control flow.",
      "Worked with AXIOS, promise-based HTTP client for the browser and node.js for hitting REST endpoints and fetching data into the app.",
    ],
  },
];
